export const elements = {
	copy: () => document.querySelectorAll('.socials__item--copy'),
	print: () => document.querySelectorAll('.socials__item--print'),
	toggle: () => document.querySelectorAll('.socials__item--share'),
};

export const showClassName = 'show';
